/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const DisplayGradesEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('DISPLAY_GRADES_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class DisplayGradesEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return DisplayGradesEnabledSettingParser.decode(input).map(res => new DisplayGradesEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return DisplayGradesEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return DisplayGradesEnabledSettingParser.encode(data);
    }
    static schema() {
        return DisplayGradesEnabledSettingParser.schema();
    }
}
